import React from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import IndicationLimitationCodeSelect from './IndicationLimitationCodeSelect';
import BaseField, {
	BaseFieldProps,
} from '../../../Base/Components/Inputs/BaseField/BaseField';

interface Props extends BaseFieldProps {
	options: SelectValue[];
}

const IndicationLimitationCodeSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<IndicationLimitationCodeSelect options={props.options} />
	</BaseField>
);

export default IndicationLimitationCodeSelectField;
